export function makeOdooOpportunityLink (id: string | number) {
  // @ts-ignore
  let url = import.meta.env.VITE_ODOO_URL;

  return `${url}/web#id=${id}&action=401&model=crm.lead&view_type=form&cids=1&menu_id=241`;
}
